const mapContactoFromApi = (contacto: $TSMigrationFixMe) => ({
  ...contacto,
  direccion: contacto?.direccion?.calle,
  email: contacto?.emails?.[0]?.contacto,
  telefono: contacto?.telefonos?.[0]?.contacto,
  cif: contacto?.nif,
  provincia: contacto?.direccion?.provinciaNombre,
  poblacion: contacto?.direccion?.poblacionNombre,
  poblacionId: contacto?.direccion?.poblacionId,
  cp: contacto?.direccion?.codigoPostal,
  poblacionExtranjera: contacto?.direccion?.poblacionExtranjera,
})

export default mapContactoFromApi
